<!-- 項目外框 -->
<template>
<div class="base-btn-layout">
  <slot></slot>
</div>
</template>
<script>
export default {
  name: 'base-btn',
  props: {
    title: String
  }
}
</script>
<style lang="stylus" scoped>

.base-btn-layout
  text-align right
  padding 20px 0

</style>
